$('body').on('click', '.next-etape', function(event){
    event.preventDefault();

    // Met à jour contenu

    // Recupere l'element du DOM contenant l'étape suivante
    let etapeElement = $(this).closest('div[data-etape]');
    let etapeNumber = etapeElement.data('etape');
    let nextEtapeNumber = etapeNumber + 1;
    let nextEtape = $(`div[data-etape=${nextEtapeNumber}]`);

    // Masque l'étape en cours
    etapeElement.addClass('d-none');

    // Affiche la prochaine étape
    nextEtape.removeClass('d-none');

    // Met à jour les onglets

    // recupere les onglets associé au étape
    let tabEtape = $(`div[data-etape-tab=${etapeNumber}]`);
    let tabNextEtape = $(`div[data-etape-tab=${nextEtapeNumber}]`);

    // Modifie les statuts des onglets
    tabEtape.addClass('valide');
    tabEtape.removeClass('active');
    tabNextEtape.addClass('active');
});

$('body').on('click', '.previous-etape', function(event){
    event.preventDefault();

    // Recupere l'element du DOM contenant l'étape precédente
    let etapeElement = $(this).closest('div[data-etape]');
    let etapeNumber = etapeElement.data('etape');
    let previousEtapeNumber = etapeNumber - 1;
    let previousEtape = $(`div[data-etape=${previousEtapeNumber}]`);

    // Masque l'étape en cours
    etapeElement.addClass('d-none');

    // Affiche l'étape précedente étape
    previousEtape.removeClass('d-none');

    // Met à jour les onglets

    // recupere les onglets associé au étape
    let tabEtape = $(`div[data-etape-tab=${etapeNumber}]`);
    let tabPreviousEtape = $(`div[data-etape-tab=${previousEtapeNumber}]`);

    // Modifie les statuts des onglets
    tabEtape.removeClass('active');
    tabEtape.removeClass('valide');
    tabPreviousEtape.addClass('active');
})

$('body').on('click', '.configurateur-etapes-item', function(){

    // Met à jour les onglets

    // empeche de déclanché l'evenement sur une table invalide
    if($(this).hasClass('valide') === false) {
        return;
    }

    // Recupère la tab cliqué et l'onglet en actuellement active
    let clickedTabNumber = $(this).data('etape-tab');
    let currentTab = $('div.configurateur-etapes-item.active');
    let currentActiveTabNumber = currentTab.data('etape-tab');

    if(clickedTabNumber > currentActiveTabNumber) {
        return;
    }

    // Supprime les class valide de toute les onglets se trouvant entre les onglets actif et l'onglet cliqué
    var i; //4 
    for(i = clickedTabNumber; i < currentActiveTabNumber; i++) { // 6
        let tab = $(`div[data-etape-tab=${i}]`);
        tab.removeClass("valide");
    }
    
    // Modifie la tab active
    $(`div[data-etape-tab=${clickedTabNumber}]`).addClass('active');
    currentTab.removeClass('active');


    // Met à jour le contenu

    let etapeElement = $(`div[data-etape=${currentActiveTabNumber}]`);
    let clickedEtape = $(`div[data-etape=${clickedTabNumber}]`);

    etapeElement.addClass('d-none');
    clickedEtape.removeClass('d-none');
});